(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cleara-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cleara-hero')) {
    class ClearaHero extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ch__track');
        this.slides = Array.from(this.querySelectorAll('.ch__slide'));
        this.dots = Array.from(this.querySelectorAll('.ch__dot'));
        this.index = 0;
        this.isSlide = this.classList.contains('ch--slide');
        this.speed = (parseFloat(this.dataset.speed) || 5) * 1000;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reduced && this.slides.length > 1;
        this.paused = false;

        if (!this.slides.length) return;

        this.querySelector('.ch__prev')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('.ch__next')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((d) => d.addEventListener('click', () => this.go(parseInt(d.dataset.go, 10), true)));

        this.addEventListener('keydown', (e) => {
          if (e.target.closest('.ch__cards')) return;
          if (e.key === 'ArrowLeft') this.go(this.index - 1, true);
          if (e.key === 'ArrowRight') this.go(this.index + 1, true);
        });

        let startX = null;
        let startY = null;
        this.addEventListener('pointerdown', (e) => {
          if (e.target.closest('.ch__cards, .ch__arrow, .ch__dot')) return;
          startX = e.clientX;
          startY = e.clientY;
        });
        this.addEventListener('pointerup', (e) => {
          if (startX === null) return;
          const dx = e.clientX - startX;
          const dy = e.clientY - startY;
          startX = null;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) this.go(this.index + (dx < 0 ? 1 : -1), true);
        });

        this.addEventListener('mouseenter', () => { this.paused = true; });
        this.addEventListener('mouseleave', () => { this.paused = false; });
        this.addEventListener('focusin', () => { this.paused = true; });
        this.addEventListener('focusout', () => { this.paused = false; });

        this.onBlockSelect = (e) => {
          const el = this.querySelector(`[data-block-id="${e.detail.blockId}"]`);
          if (!el) return;
          const slide = el.closest('.ch__slide');
          if (slide) this.go(parseInt(slide.dataset.index, 10));
          this.editorLock = true;
        };
        this.onBlockDeselect = () => { this.editorLock = false; };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.activate(0);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      start() {
        if (!this.autoplay) return;
        this.stop();
        this.timer = setInterval(() => {
          if (this.paused || this.editorLock || document.hidden) return;
          this.go(this.index + 1);
        }, this.speed);
      }

      stop() {
        clearInterval(this.timer);
      }

      go(n, fromUser) {
        const len = this.slides.length;
        this.activate(((n % len) + len) % len);
        if (fromUser) this.start();
      }

      activate(n) {
        this.index = n;
        this.slides.forEach((slide, i) => {
          const on = i === n;
          slide.classList.toggle('is-active', on);
          slide.setAttribute('aria-hidden', String(!on));
          slide.inert = !on;
          slide.querySelectorAll('video').forEach((v) => {
            if (on && v.offsetParent !== null) {
              v.muted = true;
              v.play().catch(() => {});
            } else {
              v.pause();
            }
          });
        });
        if (this.isSlide && this.track) this.track.style.transform = `translateX(-${n * 100}%)`;
        this.dots.forEach((d, i) => d.setAttribute('aria-current', String(i === n)));
      }
    }
    customElements.define('cleara-hero', ClearaHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
